import { UNKNOWN } from '@/config/staffTypes';

/**
 * Install plugin.
 *
 * @param  {Vue} Vue
*/
export default (Vue) => {
  let staffTypesForceUpdated = false;

  /**
   * Get staff type name.
   *
   * @param {string} staffType
   * @return {string}
  */
  function getStaffTypeName(staffType) {
    const name = this.$store.getters['handbook/staffTypeName'](staffType);

    if (name === UNKNOWN && !staffTypesForceUpdated) {
      this.$store.dispatch('handbook/getStaffTypes', { force: true });
      staffTypesForceUpdated = true;
    }

    return name;
  }

  Vue.prototype.$getStaffTypeName = getStaffTypeName;
};
